<style lang="scss" scoped>
.speaker-banner {
    position: relative;
    width: 100%;
    height: 360px;

    &:after {
        content: "";
        z-index: 1;
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
            225deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.5) 100%
        );

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    .content {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        padding: 0 24px;

        @media (min-width: 1024px) {
            padding: 0 40px;
        }

        .title {
            white-space: nowrap;
            line-height: 1;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .description {
            max-width: 350px;
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="mb-40 d-flex flex-wrap w-100" v-if="title">
            <h3 class="title" v-html="title"></h3>
            <a v-if="generatedCtaLink" :href="generatedCtaLink" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
        </div>
        <a v-if="speaker" class="position-relative" :href="route('nl.speaker', (speaker.slug != null ? {'slug': speaker.slug} : {'slug': speaker.post_name}))">
            <div class="mx-n24 mx-md-0">
                <div class="speaker-banner">
                    <img v-if="speaker.acf && speaker.acf.image" :src="speaker.acf.image.url" :alt="speaker.post_name">
                    <div class="content">
                        <h2 v-if="speaker.post_name" class="mb-8 text-white title">{{ speaker.post_title ? speaker.post_title : speaker.title.rendered }}</h2>
                        <p v-if="speaker.acf && speaker.acf.highlighted_title" class="text-white font-weight-light description">
                            {{ speaker.acf.highlighted_title }}
                        </p>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import hasCta from "../mixins/has-cta";

export default {
    name: "pagePart.speaker-banner-row",

    mixins: [hasCta],

    props: {
        title: {
            type: String,
            required: false,
        },
        speaker: {
            type: Object,
            required: false,
            default: () => {
                return {
                    title: '',
                    description: '',
                    image: '',
                    tags: [],
                    media: [],
                    link: ''
                };
            },
        },
        src: {
            type: String,
            required: false,
            default: '',
        },
        alt: {
            type: String,
            required: false,
            default: 'Inspire Your Tribe',
        },
    },
}
</script>